import CoreMessageDispatcher from '../../core/controller/CoreMessageDispatcher';
import CoreEvents from '../../core/events/CoreEvents';
import ChangeOrders from '../../core/events/ChangeOrders';

const _dispatcher = CoreMessageDispatcher.instance();

const _start = mdr => {
    if (mdr.started) return mdr;

    mdr._update(true);
    _addCoreListeners(mdr, true);

    mdr.started = true;
    return mdr;
};

const _stop = mdr => {
    if (!mdr.started) return mdr;

    mdr.state.isOn = false;
    mdr.win.removeEventListener('keydown', mdr._handleKeydown);
    _addCoreListeners(mdr, false);

    mdr.started = false;
    return mdr;
};

const _update = (mdr, force) => {
    if (!mdr.started && !force) return mdr;

    const isOn = true;
    let map = null;

    // SET CHAR CODE REACTIONS
    if (mdr.model.currentEventExpanded) {
        map = {
            27: ChangeOrders.COLLAPSE_CURRENT_EVENT
        };
    } else if (mdr.model.currentEventOpened) {
        map = {
            27: ChangeOrders.CLOSE_CURRENT_EVENT
        };
    } else {
        map = {
            32: ChangeOrders.OPEN_MENU,
            27: ChangeOrders.CLOSE_MENU
        };
    }
    mdr.eventMap = map;

    if (mdr.state.isOn === isOn) return mdr;

    mdr.state.isOn = isOn;

    if (isOn) {
        mdr.win.addEventListener('keydown', mdr._handleKeydown);
    } else {
        mdr.win.removeEventListener('keydown', mdr._handleKeydown);
    }

    return mdr;
};

const _handleKeydown = (mdr, evt) => {
    if (!mdr.started || !evt) return mdr;

    let e = evt;
    if (e.originalEvent) e = e.originalEvent;

    return mdr.doAction(e.keyCode || e.charCode);
};

const _doAction = (mdr, code) => {
    if (!mdr.started || !mdr.eventMap || !code) return mdr;

    const evt = mdr.eventMap[code];
    if (!evt) return mdr;

    _dispatcher.emit(evt, true);

    return mdr;
};

//

//
// From Core
//
const _addCoreListeners = (mdr, b) => {
    if (b) {
        _dispatcher.on(CoreEvents.CURRENT_EVENT_STATE_CHANGED, mdr._update);
        return;
    }

    _dispatcher.off(CoreEvents.CURRENT_EVENT_STATE_CHANGED, mdr._update);
};

//

//
// Constructor
//
const KeyboardMediator = (win, model) => {
    const mdr = {
        win: win,
        model: model,
        eventMap: null,
        state: {
            isOn: false
        }
    };

    mdr.start = () => {
        return _start(mdr);
    };

    mdr._handleKeydown = code => {
        return _handleKeydown(mdr, code);
    };

    mdr._update = force => {
        return _update(mdr, force);
    };

    mdr.doAction = code => {
        return _doAction(mdr, code);
    };

    mdr.stop = () => {
        return _stop(mdr);
    };

    return mdr;
};

export {KeyboardMediator};
export default KeyboardMediator;
